import script from "./videoDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./videoDetails.vue?vue&type=script&setup=true&lang=js"

import "./videoDetails.vue?vue&type=style&index=0&id=162fa482&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-162fa482"]])

export default __exports__